module.exports = __webpack_public_path__ + "static/mapa-f963a40a044c6bbfb5afe5e782c7ea8f.png";